<!--
  Ventana flotante de WhatsApp, anclada abajo-derecha como el compose de correo.
  Sin backdrop: no bloquea el resto de la app. Se monta UNA vez en el shell.
-->
@if (isOpen) {
<div
  class="fixed bottom-0 right-0 z-modal flex w-full flex-col overflow-hidden rounded-t-xl border border-gray-200 bg-white shadow-2xl dark:border-gray-700 dark:bg-gray-900 sm:bottom-4 sm:right-4 sm:w-[440px] sm:max-w-[calc(100vw-2rem)] sm:rounded-xl"
  [ngClass]="minimized ? '' : 'max-h-[calc(100vh-2rem)]'">

  <!-- Barra de título (clic = minimizar/restaurar) -->
  <div
    class="flex shrink-0 cursor-pointer items-center justify-between bg-emerald-700 px-4 py-2.5 text-white"
    (click)="toggleMinimize()">
    <h2 class="flex items-center gap-2 truncate text-sm font-semibold">
      <svg class="h-4 w-4 shrink-0" fill="currentColor" viewBox="0 0 24 24">
        <path d="M17.5 14.4c-.3-.2-1.8-.9-2-1-.3-.1-.5-.2-.7.1-.2.3-.7 1-.9 1.2-.2.2-.3.2-.6.1-.3-.2-1.3-.5-2.4-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6l.5-.5c.1-.2.2-.3.3-.5v-.5c-.1-.2-.7-1.6-.9-2.2-.3-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.4s1.1 2.8 1.2 3c.2.2 2.1 3.2 5 4.5.7.3 1.3.5 1.7.6.7.2 1.4.2 1.9.1.6-.1 1.8-.7 2-1.4.3-.7.3-1.3.2-1.4-.1-.2-.3-.2-.6-.3zM12 2a10 10 0 00-8.6 15.1L2 22l5-1.3A10 10 0 1012 2z" />
      </svg>
      <span class="truncate">
        WhatsApp @if (options.fullName) { · {{ options.fullName }} }
      </span>
    </h2>
    <div class="flex items-center gap-1">
      <button type="button" (click)="$event.stopPropagation(); toggleMinimize()"
        class="rounded p-1 text-emerald-100 transition-colors hover:bg-white/10 hover:text-white"
        [title]="minimized ? 'Restaurar' : 'Minimizar'">
        <span class="block h-4 w-4 text-center text-xs leading-4">{{ minimized ? '▲' : '▬' }}</span>
      </button>
      <button type="button" (click)="$event.stopPropagation(); close()"
        class="rounded p-1 text-emerald-100 transition-colors hover:bg-white/10 hover:text-white"
        title="Cerrar">
        <span class="block h-4 w-4 text-center text-sm leading-4">×</span>
      </button>
    </div>
  </div>

  @if (!minimized) {
    <div class="flex-1 overflow-y-auto p-4">
      @if (loading) {
        <p class="py-8 text-center text-sm text-gray-500 dark:text-gray-400">Cargando…</p>
      } @else if (blockedMessage) {
        <div class="rounded-lg border border-amber-200 bg-amber-50 px-3 py-3 text-sm text-amber-800 dark:border-amber-900/40 dark:bg-amber-900/20 dark:text-amber-200">
          {{ blockedMessage }}
          @if (templates.length === 0 && phones.length > 0) {
            <a routerLink="/whatsapp/plantillas" (click)="close()" class="ml-1 font-medium underline">
              Crear uno ahora
            </a>
          }
        </div>
      } @else {
        <!-- Destinatario -->
        <label class="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-300">Para</label>
        <input
          type="text"
          [(ngModel)]="to"
          placeholder="+51 987 654 321"
          class="mb-1 w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-900 dark:border-gray-700 dark:bg-gray-800 dark:text-white"
        />
        @if (options.fullName) {
          <p class="mb-3 text-xs text-gray-400 dark:text-gray-500">{{ options.fullName }}</p>
        } @else {
          <div class="mb-3"></div>
        }

        <!-- Desde: sólo si el usuario tiene más de un número -->
        @if (phones.length > 1) {
          <label class="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-300">Enviar desde</label>
          <select
            [(ngModel)]="phoneId"
            class="mb-3 w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-900 dark:border-gray-700 dark:bg-gray-800 dark:text-white"
          >
            @for (p of phones; track p.id) {
              <option [value]="p.id">{{ p.displayPhoneNumber }}</option>
            }
          </select>
        }

        <!-- Plantilla -->
        <label class="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-300">
          Elige el mensaje
        </label>
        <select
          [(ngModel)]="selectedName"
          (ngModelChange)="onTemplateChange()"
          class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-900 dark:border-gray-700 dark:bg-gray-800 dark:text-white"
        >
          <option value="">Elige uno…</option>
          @for (t of templates; track t.name + t.language) {
            <option [value]="t.name">{{ prettyName(t.name) }}</option>
          }
        </select>
        <p class="mt-1 text-[11px] text-gray-400 dark:text-gray-500">
          Como el cliente aún no te escribió, WhatsApp sólo permite estos mensajes aprobados.
        </p>

        @if (selected) {
          @if (needsMedia) {
            <div class="mt-3 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-800 dark:border-amber-900/40 dark:bg-amber-900/20 dark:text-amber-200">
              Este mensaje lleva una imagen o un archivo, y eso sólo se puede adjuntar desde la
              bandeja de WhatsApp. Elige otro, o escríbele desde
              <a routerLink="/whatsapp/chat" (click)="close()" class="font-medium underline">la bandeja</a>.
            </div>
          }

          @if (params.length) {
            <div class="mt-3 space-y-2">
              @for (p of params; track $index) {
                <div>
                  <label class="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-300">
                    {{ paramLabel($index) }}
                  </label>
                  <input
                    type="text"
                    [(ngModel)]="params[$index]"
                    class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-900 dark:border-gray-700 dark:bg-gray-800 dark:text-white"
                  />
                </div>
              }
            </div>
          }

          <!-- Vista previa -->
          <p class="mt-4 mb-1 text-xs font-medium text-gray-700 dark:text-gray-300">
            Así le llegará
          </p>
          <div class="rounded-xl bg-[#e5ddd5] p-3 dark:bg-gray-800">
            <div class="rounded-lg rounded-tr-none bg-[#dcf8c6] p-3 shadow-sm dark:bg-emerald-900/40">
              @if (selected.headerText) {
                <p class="mb-1 text-sm font-semibold text-gray-900 dark:text-white">
                  {{ selected.headerText }}
                </p>
              }
              <p class="whitespace-pre-wrap text-sm text-gray-800 dark:text-gray-100">
                {{ preview }}
              </p>
            </div>
          </div>
        }
      }
    </div>

    @if (!loading && !blockedMessage) {
      <div class="flex shrink-0 items-center justify-end gap-2 border-t border-gray-200 px-4 py-3 dark:border-gray-800">
        <button type="button" (click)="close()"
          class="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-200 dark:hover:bg-gray-800">
          Cancelar
        </button>
        <button type="button" (click)="send()" [disabled]="!canSend"
          class="rounded-lg bg-emerald-600 px-4 py-2 text-sm font-medium text-white hover:bg-emerald-700 disabled:opacity-50">
          @if (sending) { Enviando… } @else { Enviar }
        </button>
      </div>
    }
  }
</div>
}
